define('appkit/adapter/filter',[ 
  './param'
], function(ParamAdapter) {

  var FilterAdapter = ParamAdapter.extend({

    serializeFilter: function() {
      var data    = this.model.toJSON(),
          options = this.options;
          
      _.each(options.format, function(fn, key) {
        if (data[key]) {
          fn.call(this, data[key], this.model, data, key);
        }
      }, this);

      return data;
    }

  });

  return FilterAdapter;
});
